import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { injectModels } from "../../../redux/injectModels";
import { routes } from "../../../constants/routes";
import { DocumentService } from "../../../services";
import { EventService } from "../../../services";
import { handleConsoleError } from "../../../utils/common-methods";

const EventDocumentModel = {
  id: "",
  eventName: "",
  eventId: "",
  documentName: "",
  documentFile: "",
  isActive: false,
};

const CreateDocument = (props) => {
  const id = DocumentService.getDocumentId();
  const navigate = useNavigate();
  const [documentData, setDocumentData] = useState({ ...EventDocumentModel });
  const [file, setFile] = useState(null);
  const { eventId } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const maxSize = 20 * 1024 * 1024;
  const validTypes = [
    "application/pdf",
    // "image/png",
    // "image/gif",
    // "image/jpeg",
  ];

  const getEventDocumentByid = async () => {
    try {
      props.application.setLoading(true);
      const res =
        (id && (await DocumentService.getEventDocumentById(id))) || [];

      const pitchMappedData = { ...EventDocumentModel, ...res?.data };

      if (res?.data?.documentFileURL) {
        // Optionally handle file display logic here
        pitchMappedData.documentFile = res?.data?.documentFileURL;
        setFile(res?.data?.documentFileURL);
      }
      setDocumentData(pitchMappedData);
      reset(pitchMappedData);
      props.application.setLoading(false);
    } catch (error) {
      reset(EventDocumentModel);
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    getEventDocumentByid();
  }, []);

  const onSubmit = async (data) => {
    if (!file) {
      alert("Please upload a file before saving.");
      return;
    }
    try {
      props.application.setLoading(true);
      let response = null;
      const formData = new FormData();
      formData.append("eventId", eventId || "");
      formData.append("documentName", documentData?.documentName);
      formData.append("documentFile", file);
      formData.append("isActive", documentData?.isActive);

      if (id) {
        // Update existing document

        formData.append("id", id);
        response = await DocumentService.updateEventDocument(formData);
      } else {
        // Create new document
        response = await DocumentService.addEventDocument(formData);
      }
      if (response?.isSuccess) {
        props.application.setLoading(false);
        toast.success(response?.message);
        DocumentService.removeDocumentId();
        navigate(routes.EVENT_DOCUMENT.replace(":eventId", eventId));
      } else {
        props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (error) {
      props.application.setLoading(false);
      toast.error(error?.message);
    }
  };

  const handleIsStatus = (event) => {
    setDocumentData({
      ...documentData,
      isActive: event.target.checked ? true : false,
    });
  };

  const handleFileChange = (e) => {
    const fileTemp = e.target.files[0];
    let newErrorMessage = "";
    if (fileTemp) {
      if (!validTypes.includes(fileTemp.type)) {
        newErrorMessage = `File "${
          fileTemp.name
        }" is not a valid document type. Allowed types: ${validTypes
          .join(", ")
          .replace("application/", "")}`;
      } else if (fileTemp.size > maxSize) {
        newErrorMessage = `File "${
          fileTemp.name
        }" exceeds the maximum size of ${maxSize / (1024 * 1024)}MB.`;
      } else {
        setError("documentFile", { message: "" });
        setFile(e.target.files[0]);
        setValue("documentData.documentFile", e.target.files[0]);
        clearErrors("documentFile");
      }

      if (newErrorMessage.length > 3) {
        setError("documentFile", { message: newErrorMessage });
        e.target.value = "";
      }
    }
  };

  return (
    <React.Fragment>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group controlId="documentName" className="mb-3">
          <Form.Label>
            Document Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength={100}
            type="text"
            {...register("documentName", {
              required: "Please enter Document Name",
            })}
            defaultValue={documentData?.documentName}
            onChange={(e) =>
              setDocumentData({ ...documentData, documentName: e.target.value })
            }
          />
          {errors.documentName && (
            <span className="text-danger">{errors.documentName?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="documentFile" className="mb-3">
          <Form.Label>Document File </Form.Label>
          <Form.Control
            type="file"
            accept=".pdf,application/pdf"
            onChange={handleFileChange}
            className="mb-3"
          />
          {errors.documentFile && (
            <span className="text-danger">{errors.documentFile?.message}</span>
          )}
        </Form.Group>
        {file && typeof file === "string" && (
          <a href={file} target="_blank" rel="noopener noreferrer">
            View Uploaded File
          </a>
        )}

        <Form.Group controlId="refundable" className="mb-3">
          <Form.Label>Status</Form.Label>
          <Form.Check
            type="checkbox"
            checked={documentData?.isActive} // Controlled by state
            onChange={handleIsStatus} // Handle change event
          />
        </Form.Group>

        <button
          className="btn btn-primary mt-3"
          type="button"
          onClick={handleSubmit(onSubmit)}
        >
          Save
        </button>
      </Form>
    </React.Fragment>
  );
};

export default injectModels(["application"])(CreateDocument);
